import React from 'react';

import { isMobile } from '../../helpers/utils';
import './style.css';
import './mobileStyle.css';
import LoadingMask from '../LoadinngMask/LoadingMask';

const Widget = props => {
    const { heading, details, isLoadingOrError, route, subRoute, propNames, accountNumber, accountAlertName, nickname } = props;

    if (isLoadingOrError === "PENDING") {
        return <LoadingMask NavigationLink={``} />;
    }

    if (isLoadingOrError === "FAILED") {
        return <div>error</div>
    }

    return (
        <div className={`widget ${isMobile() ? 'mobileWidget' : ''}`}>
            <div className="widget-header">
                {{ heading } === 'managetextbanking' ? '' : <h2> {heading} </h2> }
            </div>

            <div className={isMobile()?"mobile-widget-container": "widget-container"}>
                <ul>
                    {
                        details && details.map((detail, i) => {                                                                                            
                            let href = `${route}/${detail[propNames] || detail.number || detail.id || subRoute[i]}`                           
                            /* eslint-disable-next-line */
                            href = route == "#/accountalerts" ? href + '/' + detail.name + '/' + detail.nickname : href;

                            href = route === "#/accountalerttypes" ? href + '/' + accountNumber + '/' + nickname + '/'  + accountAlertName : href; 

                            return (                             
                                <li key={i}>
                                    <a href={href} className="App-link">
                                        <div className="widget-link">
                                            <div>
                                                {
                                                    // Banking Alert Groups use Title
                                                    detail.title ||
                                                    // Account Alerts use Name or DisplayName
                                                    detail.name ||
                                                    (detail.displayName && detail.displayName.toLowerCase()) ||
                                                    // Everything else uses the value passed
                                                    detail
                                                }
                                            </div>
                                            {
                                                isMobile() &&
                                                <div>
                                                    <img src="images/Chevron.png" alt="next-page-icon" />
                                                </div>
                                            }
                                        </div>
                                    </a>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </div>
    )
};

export default Widget;
